import { Tag } from '@models/tag';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';
import { getLanguageByCode } from '@helpers/languages';
import { AdminCarouselItem } from '@models/section/cardCarouselSection';
import { httpGet } from './apiService';

export class TagAdminService extends SlugEntityAdminApiService<Tag> {
    constructor() {
        super('/api/admin/tag');
    }

    public getCarouselItems = async (languageCode: string): Promise<AdminCarouselItem[]> => {
        const languageId = getLanguageByCode(languageCode)?.id || 1;
        return (await this.getAll(languageId)).map((tag) => ({
            content: tag.name,
            value: tag.id,
        }));
    };

    public getAllPrimary = async (languageId: string): Promise<Tag[]> => {
        const response = await httpGet(`${this.baseUrl}/all-primary/${languageId}`);
        return this.returnArrayResult(await response.json());
    };
}
